import React, {useState, useEffect, useRef} from "react";
import "./App.css";
import {useLessons} from "./DataContext";
import {getBookName, localStorageGetItem, ReadHebrewText} from "./misc";
import params from "./data/params.json";

import {useServer} from "./ServerContext"

const CourseViewer = ({lessons, onBack}) => {

    const {ServerEvents, addEvent2ServerQueue, isAllowedCoursesLearned} = useServer();

    const {allLessons, courseFilenames} = useLessons();

    // The selected lesson
    const [selectedLesson, setSelectedLesson] = useState(lessons[0]);
    useEffect(() => {
        for (let l of lessons) {
            if (courseFilenames?.[l]) setSelectedLesson(l)
        }
    }, [courseFilenames])

    const [htmlContent, setHtmlContent] = useState(null);
    useEffect(() => {
            const loadHtmlFile = async () => {
                const res = await fetch(courseFilenames[selectedLesson]);
                const text = await res.text();
                setHtmlContent(text);
            };
            if (courseFilenames && courseFilenames?.[selectedLesson]) loadHtmlFile();
        }, [selectedLesson, courseFilenames]
    );

    function extractBodyContent(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return doc.body.innerHTML;
    }

    const containerRef = useRef();

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        function onHebrewClick(text) {
            ReadHebrewText(text);
        }

        function handleClick(e) {
            onHebrewClick?.(e.currentTarget.textContent);
        }

        const attachClickEvents = () => {
            const hebrewElements = container.querySelectorAll('.hebrew');
            hebrewElements.forEach(el => {
                el.style.cursor = 'pointer';
                el.removeEventListener('click', handleClick); // pour éviter doublons
                el.addEventListener('click', handleClick);
            });
        };

        // Attacher une première fois, au cas où les éléments sont déjà là
        attachClickEvents();

        // Observer si des éléments .hebrew sont ajoutés plus tard
        const observer = new MutationObserver(() => {
            attachClickEvents();
        });

        observer.observe(container, {
            childList: true,
            subtree: true,
        });

        // Cleanup
        return () => {
            observer.disconnect();
            const hebrewElements = container.querySelectorAll('.hebrew');
            hebrewElements.forEach(el => {
                el.removeEventListener('click', handleClick);
            });
        };
    }, [htmlContent]);


    const [learned, setLearned] = useState(() => {
        const courseName = params[getBookName()].lessons[selectedLesson].file
        return localStorage.getItem("coursesLearned") ? JSON.parse(localStorage.getItem("coursesLearned"))[courseName] : false
    });
    useEffect(() => {
        const courseName = params[getBookName()].lessons[selectedLesson].file
        let coursesLearned = JSON.parse(localStorage.getItem("coursesLearned")) || {}
        if (coursesLearned[courseName] !== learned) addEvent2ServerQueue("updateCourses");
        coursesLearned[courseName] = learned
        localStorage.setItem("coursesLearned",JSON.stringify(coursesLearned))

    }, [learned])


    const leave = () => {
        onBack();
    }

    if (!allLessons) return;

    return (
        <div className="main-container course-display">
            <div className="title-container top">
                <button className="button-secondary" onClick={() => {
                    leave();
                }}> ⬅️
                </button>
                <div className="title-container-title">
                    Leçons
                </div>
            </div>

            <div className="section-container">

                <div className={"section-container-line"}>

                    {/* MENU SELECTED LESSON */}
                    <select value={selectedLesson}
                            id={"selected-lesson-select"}
                            onChange={(e) => setSelectedLesson(Number(e.target.value))}
                    >
                        {lessons.map((lesson, index) => (
                            <option key={lesson}
                                    value={lesson}
                                    disabled={courseFilenames?.[lesson] === null}
                            >
                                {allLessons[lesson].course}
                            </option>
                        ))}
                    </select>
                </div>
            </div>


            <div className="section-container course">
                <div className="lesson-button-container">
                    <button
                        className={`lesson-status-button ${learned ? "active" : "non-active"}`}
                        onClick={() => setLearned(!learned)}
                        disabled = {!isAllowedCoursesLearned}
                    >
                        {(learned ? "leçon apprise" : "Leçon non apprise") +
                            (isAllowedCoursesLearned ? " (cliquez pour changer statut)" : " (en attente de connexion)")}
                    </button>
                </div>
                {htmlContent && (
                    <div ref={containerRef}
                         className="mt-4 border p-4 course-container"
                         dangerouslySetInnerHTML={{__html: extractBodyContent(htmlContent)}}
                    />
                )}
            </div>
        </div>
    );
}

export default CourseViewer;
